<div class="input-group">
  <input
    class="form-control"
    [placeholder]="placeholder"
    name="dp"
    ngbDatepicker
    #d="ngbDatepicker"
    [autoClose]="'outside'"
    [displayMonths]="1"
    [navigation]="'select'"
    [startDate]="parsedValue"
    [value]="displayValue"
    (click)="d.toggle()"
    (dateSelect)="onDateSelect($event, d)"
  />
  <div class="input-group-append">
    <button
      class="btn btn-outline-secondary"
      (click)="d.toggle()"
      type="button"
    >
      <i class="fa fa-calendar"></i>
    </button>
    <button
      *ngIf="parsedValue"
      class="btn btn-outline-danger"
      (click)="clearDate(d)"
      type="button"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>
